import { PortableText } from "@portabletext/react";
import React, { useEffect } from "react";
import { components } from "../api/sanity/portableText";
import { CallToAction, ContactInfo, Layout, Newsletter } from "../components";
import { useAbout } from "../redux/hooks/hooks";
import { fetchAboutFromStrapi, fetchContactFromStrapi } from "../redux/actions/aboutActions";
import { useDispatch } from "react-redux";
import DataLoader from "../components/loader/DataLoader";
import useDataLoader from "../hooks/useDataLoader";
import { useLanguage } from "../context";
import PageHero from "../components/common/PageHero";
import SectionHeader from "../components/common/SectionHeader";

const About = () => {
  const data = useAbout();
  const dispatch = useDispatch();
  const { language } = useLanguage();

  useEffect(() => {
    // Fetch data from Strapi and update Redux store
    dispatch(fetchAboutFromStrapi(language));
    dispatch(fetchContactFromStrapi(language));
  }, [dispatch, language]);

  // Utiliser le hook personnalisé pour gérer l'état de chargement
  const loading = useDataLoader(data, data === undefined || data === null);

  // Afficher le loader tant que les données ne sont pas chargées
  if (loading) {
    return <DataLoader isLoading={true} />;
  }

  return (
    <Layout data={data}>
      {data && (
        <>
          <PageHero
            eyebrow="Africa Systems"
            title={data?.hero?.title}
            description={data?.hero?.description}
            image={data?.hero?.image}
          />
          <div className="py-16 lg:py-20 bg-white">
            <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12">
              <SectionHeader
                eyebrow="Africa Systems"
                title={data?.hero?.title}
                description={data?.hero?.description}
              />
              <div className="flex flex-col md:flex-row w-full gap-8 lg:gap-12">
                <div className="w-full md:w-2/3">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {data?.statsBlock?.map((stat, index) => (
                      <div
                        key={index}
                        className="p-4 bg-white border border-slate-200 hover:border-[#16A34A]/40 hover:shadow-lg transition-all duration-300"
                      >
                        <hr className="w-10 h-1 bg-[#16A34A]" />
                        <div className="flex gap-2 font-[400] text-[#0a1628] pt-2">
                          <span>{stat.value}</span>
                          <span>{stat.title}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="py-8 text-justify">
                    <PortableText
                      value={data?.description}
                      components={components(false)}
                      onMissingComponent={false}
                    />
                  </div>
                </div>
                <div className="w-full md:w-1/3">
                  <ContactInfo />
                  <div className="flex justify-center pt-8">
                    <CallToAction />
                  </div>
                  <div className="pt-8">
                    <Newsletter />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default About;